import type { SupportedRepubName } from './types';

export type MatchupCentreConfig = {
  /**
   * Event to pre-select on load. Omit for no filter ("All").
   *
   * Prefer a populated league over omitting. Query cost scales with how many subevents are in
   * scope, not with page size, so "All" measured 11.4 s against 1.0 s for a single league on STG —
   * see the SPOR-2373 plan. Omit only where no league dominates the repub.
   *
   * Whatever is set must actually have upcoming fixtures. A default matching zero documents does
   * not render an empty page; `CategoriesRefinement` clears it and re-queries, so every load costs
   * an extra search and lands on the slow unfiltered path.
   */
  defaultEventDisplayName?: string;
  matchCenterLabel: string;
  matchCenterPath: string;
};

/**
 * Matchup Centre configurations for each republic
 */
export const MATCHUP_CENTRE_CONFIGS = {
  GZ: {
    defaultEventDisplayName: 'Serie A',
    matchCenterLabel: 'Match Center',
    matchCenterPath: 'match-centre',
  },
  OC: {
    defaultEventDisplayName: 'EPL',
    matchCenterLabel: 'Match Centre',
    matchCenterPath: 'match-centre',
  },
  US: {
    defaultEventDisplayName: 'NFL',
    matchCenterLabel: 'Match Center',
    matchCenterPath: 'match-center',
  },
  // No single league dominates WS, so it takes the unfiltered view and its cost.
  WS: {
    matchCenterLabel: 'Match Centre',
    matchCenterPath: 'match-centre',
  },
} satisfies Record<SupportedRepubName, MatchupCentreConfig>;
